/**
 * Created by Bob.Bao on 2017/12/18.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import bids from './modules/bids'
import form from './modules/form'
import meta from './modules/meta'
import supplier from './modules/supplier'

Vue.use(Vuex)

export default new Vuex.Store({
    //actions,
    //getters,
    modules: {
        meta,//元数据
        supplier,//供应商所有数据
        bids,
        form
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js